import { RoleModel } from './../definition/system.model';
import { Injectable, Injector } from '@angular/core';
import { GenericApiService } from 'shared/services';

@Injectable({
    providedIn: 'root'
})
export class RoleApiService extends GenericApiService<RoleModel, any> {

    constructor(
        injector: Injector,
    ) {
        super(injector, 'role');

    }

    getPermissions(id: string) {
        return this.httpClient.get<string[]>(`${this.apiUrl}/${id}/permissions`);
    }

    savePermissions(id: string, permissions: string[]) {
        return this.httpClient.post(`${this.apiUrl}/${id}/permissions`, permissions);
    }

    getRolesByProjectId(projectid: string) {
        return this.httpClient.get<RoleModel[]>(`${this.apiUrl}/${projectid}/roles`);
    }

    getRolesWhereProjectId(projectid: string) {
        return this.httpClient.get<RoleModel[]>(`${this.apiUrl}/roles/${projectid}`);
    }

    getRolesByFullName(fullName: string) {
        return this.httpClient.get<RoleModel[]>(`${this.apiUrl}/roles/getRolesByFullNames/${fullName}`);
    }

    getCurrentRoles() {
        return this.httpClient.get<RoleModel[]>(`${this.apiUrl}/roles/getCurrentRoles`);
    }
    
    getAllRoles() {
        return this.httpClient.get<RoleModel[]>(`${this.apiUrl}`);
    }
}
